import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

import {
  Indikator,
  IndikatorTable,
  PaginatedResponse,
  ApiResponse
} from '../interfaces/indikatoren.interface';

@Injectable({
  providedIn: 'root'
})
export class IndikatorenService {
  private apiUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient) { }

  // Get all indicators with pagination
  getIndikatoren(page: number = 1, limit: number = 10, search?: string, sortBy?: string, sortOrder?: string): Observable<PaginatedResponse<IndikatorTable>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    
    if (search) {
      params = params.set('search', search);
    }
    
    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }
    
    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    return this.http.get<PaginatedResponse<IndikatorTable>>(`${this.apiUrl}/indikatoren`, { params });
  }

  // Get single indicator by ID
  getIndikator(id: number): Observable<Indikator> {
    return this.http.get<ApiResponse<Indikator>>(`${this.apiUrl}/indikatoren/${id}`)
      .pipe(map(response => response.data));
  }

  // Create new indicator
  createIndikator(indikator: Partial<Indikator>): Observable<Indikator> {
    return this.http.post<ApiResponse<Indikator>>(`${this.apiUrl}/indikatoren`, indikator)
      .pipe(map(response => response.data));
  }

  // Update indicator
  updateIndikator(id: number, indikator: Partial<Indikator>): Observable<Indikator> {
    return this.http.put<ApiResponse<Indikator>>(`${this.apiUrl}/indikatoren/${id}`, indikator)
      .pipe(map(response => response.data));
  }

  // Delete indicator
  deleteIndikator(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/indikatoren/${id}`);
  }
} 